import React from 'react';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import './AgGrid.scss';

const AgGrid = React.memo(({colDefs, rowData, ...restProps}: any) => {
    return (
        <div
         className="ag-theme-quartz"
         style={{ height: 408 }}
        >
          <AgGridReact
              rowData={rowData}
              columnDefs={colDefs}
              {...restProps}
          />
        </div>
       )  
});

AgGrid.displayName = 'AgGrid';

export default AgGrid;
